import {Injectable} from '@angular/core';
import {Action, Selector, State, StateContext, Store} from '@ngxs/store';
import {
  ChangeCurrencyAction,
  ChangeRateCardForJobAction,
  CreateInvoiceAction,
  FindAllCurrencyAction,
  FindCommitmentInvoicesForOrgAction,
  FindByInvoiceTypeAndApprovalTypeAction,
  FindByInvoiceTypeAndOverdueTypeAction,
  FindCommitmentContractOrganizations,
  FindInvoiceByIdAction,
  GetAllTaxByCountryAction,
  GetCustomersIdsAction,
  GetInvoiceAbleJobsAction,
  GetInvoiceLoadsLimit,
  GetLoadsByJobFileAndCompletedAction,
  GetLoadsForJobFileAction,
  GetNoOfCompletedLoadsForCreatedToAction,
  GetOrgDetailsAction,
  GetPreSignedFile,
  GetReceivedInvoicesAction,
  GetRateCardsByIds,
  GetSupplierIdsAction,
  LoadRateCardsAction,
  AddLoadsToInvoiceAction,
  RemoveAllLoadsAction,
  RemoveLoadAction,
  RemoveSelectedLoadsAction,
  ResetInvoiceState,
  SetInvoiceLabelFilterAction,
  FindCommitmentInvoiceOrgIdsByLabelAction,
  ClearInvoicesListAction,
  SelectAllLoadsAction,
  SelectLoadAction,
  UpdateInvoiceAction,
  UploadPdfAndGetId,
  SelectAllLoadsActionByOrg,
  UpdateReadyToInvoiceAction,
  ChangeInvoicedStateAction,
  SelectInvoicesAction,
  UpdateFuelRateInvoicedStateAction,
  UpdateExpensesAction,
  UpdateInvoicePageStatusAction,
  ResetInvoiceMainState,
  LoadCustomersAction,
  DownloadInvoicesAction,
  LoadAllCustomersAction,
  UpdateReceivableOtherContractFilterAction,
  UpdatePayableOtherContractFilterAction,
  GetAllCompletedLoadsForSelectionAction,
  ClearAllCompletedLoadsForSelectionAction,
  DisputeInvoiceItemAction,
  AcceptInvoiceItemAction
} from './invoice.actions';
import {InvoiceStateModel} from '../../models/state/invoice-state.model';
import {of, Subject, throwError} from 'rxjs';
import {catchError, map, mergeMap, tap} from 'rxjs/operators';
import {SetNotificationAction} from '@core/store/notification/notification.actions';
import {AlertDialogType} from '@shared/models';
import {GraphqlClientService} from '@core/services/graphql-client.service';
import {InvoiceService} from '../../services/invoice.service';
import {OrgDetails} from '@shared/models/org-details.model';
import {EntityMap} from '@shared/models/types';
import {PageInvoiceAbleJobs} from '../../models/pagiable-invoice-able-jobs.model';
import {PageReadyToInvoice} from '../../models/pagiable-ready-to-invoice.model';
import {InvoiceLoad} from '../../models/invoice-load.model';
import {ReadyToInvoice} from '../../models/ready-to-invoice';
import {produce} from 'immer';
import {PageInvoices} from '../../models/pagiable-invoice.model';
import {Invoice} from '@shared/models/invoice/invoice.model';
import {Tax} from '../../models/tax.model';
import {RateCard} from '@shared/models/rate-card.model';
import {LoadsCount} from '../../models/loads-count.model';
import {SetSpinner, SetDownloadProgress} from '@core/store/shared.actions';
import {Router} from '@angular/router';
import { OtherContractFilter, getDefaultOtherContractFilter } from '../../models/other-contract-filter.model';
import {FirebaseService} from '@core/services/firebase.service';
import {DownloadDialogManagerService} from '@core/services/download-dialog-manager.service';

import {
  changeRateCardForTrip,
  countCompletedLoadsByCreatedTo,
  createInvoice,
  fidByCountry,
  findAllCompletedLoadsByJob,
  findAllCurrency,
  findByInvoiceTypeAndOverdueType,
  findCustomers,
  findInvoiceAbleJobs,
  findInvoiceById,
  findInvoicesByInvoiceTypeAndApprovalType,
  findReceivedInvoicesByApprovalState,
  findCommitmentInvoicesForOrganization,
  findCommitmentInvoiceOrganizationIds,
  findLoadsByJobRefId,
  findLoadsByJobRefIdAndIsCompleted,
  findSuppliers,
  addLoadsToInvoice,
  removeAllLoads,
  removeLoad,
  updateInvoice,
  uploadPdfAndGetId,
  findAllCompletedLoadsByOrg,
  updateReadyToInvoiceCostsDiscounts,
  changeInvoicedState,
  findInvoicesByIds, updateInvoicedState, updateExpenses,
  downloadInvoicesDetailedReport,
  disputeInvoiceItem,
  acceptInvoiceItem
} from '../../queries/invoice.query';
import {Currency} from '@shared/models/currency.model';
import {Cost} from '../../models/cost.model';
import {InvoiceType} from '../../models/enums/invoice-type.enum';
import {RtiExtraServiceService} from '../../services/rti-extra-service.service';
import { InvoicePageStatusFilter } from '../../models/invoice-page-status.model';
import { ApprovalStateType } from '../../models/enums/approval-state.enum';
import { TabType } from '../../models/enums/invoice-state.enum';
import {Organization} from '../../../organization/models/organization';
import { OrganizationType } from 'app/modules/organization/models/enums/organization-type';
import { DropDownValue } from 'app/modules/dynamic-form/models/drop-down-value';
import { OrganizationService } from 'app/modules/organization/services/organization.service';
import { subscribe } from 'graphql';

export const getNewInvoice = (): InvoiceStateModel => ({
  orgDetails: {},
  customerIds: [],
  supplierIds: [],
  commitmentContractOrgIds: [],
  jobsForCreatedTo: {},
  completedLoadsForJob: {},
  pendingLoadsForJob: {},
  loadsForJob: {},
  selectedLoads: {},
  selectedInvoice: null,
  invoices: {},
  taxes: [],
  rateCards: [],
  noOfCompletedLoadsForCreatedTo: {},
  pdfFileId: null,
  currencies: [],
  supplierInvoices: {},
  selectedInvoices: {},
  invoicePageStatus: {},
  customers: [],
  invoicesAll: {},
  allCustomers: [],
  receivableOtherContractFilter: getDefaultOtherContractFilter(),
  payableOtherContractFilter: getDefaultOtherContractFilter(),
  allCompletedLoadsForSelection: {},
  labelFilterIds: [],
  labelMatchedCommitmentOrgIds: null
}) as InvoiceStateModel;

@State<InvoiceStateModel>({
  name: 'invoice',
  defaults: getNewInvoice()
})
@Injectable()
export class InvoiceState {
  endpoint = 'invoice-endpoint';

  constructor(
    private router: Router,
    public store: Store,
    private gqlService: GraphqlClientService,
    private invoiceService: InvoiceService,
    private rtiExtraServiceService: RtiExtraServiceService,
    private organizationService: OrganizationService,
    private firebaseService: FirebaseService,
    private downloadDialogManager: DownloadDialogManagerService
  ) {
  }

  /** PB-5281: the label filter as a GraphQL variable (null = no filter). */
  private labelIds(getState: () => InvoiceStateModel): string[] | null {
    const labelIds = getState().labelFilterIds;
    return labelIds?.length ? labelIds : null;
  }

  @Action(SetInvoiceLabelFilterAction)
  setInvoiceLabelFilter({patchState}: StateContext<InvoiceStateModel>, {labelIds}: SetInvoiceLabelFilterAction) {
    patchState({
      labelFilterIds: labelIds || [],
      ...(labelIds?.length ? {} : {labelMatchedCommitmentOrgIds: null})
    });
  }

  @Action(FindCommitmentInvoiceOrgIdsByLabelAction)
  findCommitmentInvoiceOrgIdsByLabel({patchState, dispatch, getState}: StateContext<InvoiceStateModel>,
                                     {orgId, invoiceType, fromDate, toDate}: FindCommitmentInvoiceOrgIdsByLabelAction) {
    const labelIds = this.labelIds(getState);
    if (!labelIds) {
      patchState({labelMatchedCommitmentOrgIds: null});
      return;
    }
    const variables = {orgId, invoiceType, fromDate, toDate, labelIds};
    return this.gqlService
      .queryDataFromGQL<string[]>(variables, findCommitmentInvoiceOrganizationIds, 'findCommitmentInvoiceOrganizationIds', this.endpoint)
      .pipe(
        tap(orgIds => {
          // Ignore a response that arrives after the labels were cleared or changed.
          if (this.labelIds(getState)?.join(',') === labelIds.join(',')) {
            patchState({labelMatchedCommitmentOrgIds: orgIds || []});
          }
        }),
        catchError(() => dispatch(new SetNotificationAction('Unable to filter customers by label', AlertDialogType.ERROR)))
      );
  }

  @Selector()
  static getCustomerIds(state: InvoiceStateModel): string[] {
    return [...state.customerIds].sort();
  }

  @Selector()
  static getSupplierIds(state: InvoiceStateModel): string[] {
    return [...state.supplierIds].sort();
  }

  @Selector()
  static getOrgDetailsAsArray(state: InvoiceStateModel): OrgDetails[] {
    return Object.keys(state.orgDetails).map((id: string) => state.orgDetails[id]);
  }

  @Selector()
  static getOrgDetails(state: InvoiceStateModel): EntityMap<string, OrgDetails> {
    return state.orgDetails;
  }

  @Selector()
  static getJobsForCreatedTo(state: InvoiceStateModel): EntityMap<string, PageInvoiceAbleJobs> {
    return state.jobsForCreatedTo;
  }

  @Selector()
  static getCompletedLoadsForJob(state: InvoiceStateModel): EntityMap<string, PageReadyToInvoice> {
    return state.completedLoadsForJob;
  }

  @Selector()
  static getPendingLoadsForJob(state: InvoiceStateModel): EntityMap<string, PageReadyToInvoice> {
    return state.pendingLoadsForJob;
  }

  @Selector()
  static getLoadsForJob(state: InvoiceStateModel): EntityMap<string, PageReadyToInvoice> {
    return state.loadsForJob;
  }

  @Selector()
  static getSelectedLoadsAsArray(state: InvoiceStateModel): InvoiceLoad[] {
    return Object.keys(state.selectedLoads).map((id: string) => state.selectedLoads[id]);
  }

  @Selector()
  static getInvoices(state: InvoiceStateModel): EntityMap<string, PageInvoices> {
    return state.invoices;
  }

  @Selector()
  static getInvoicesAll(state: InvoiceStateModel): EntityMap<string, PageInvoices> {
    return state.invoicesAll;
  }

  @Selector()
  static getSupplierInvoices(state: InvoiceStateModel): EntityMap<string, PageInvoices> {
    return state.supplierInvoices;
  }

  @Selector()
  static getSelectedInvoice(state: InvoiceStateModel): Invoice {
    return state.selectedInvoice;
  }

  @Selector()
  static getAllTaxes(state: InvoiceStateModel): Tax[] {
    return state.taxes;
  }

  @Selector()
  static getRateCards(state: InvoiceStateModel): RateCard[] {
    return state.rateCards;
  }

  @Selector()
  static getNoOfCompletedLoadsForCreatedTo(state: InvoiceStateModel): EntityMap<string, number> {
    return state.noOfCompletedLoadsForCreatedTo;
  }

  @Selector()
  static getPdfFileId(state: InvoiceStateModel): string {
    return state.pdfFileId;
  }

  @Selector()
  static getCurrencies(state: InvoiceStateModel): Currency[] {
    return state.currencies;
  }

  @Selector()
  static getRateCardsMap(state: InvoiceStateModel): EntityMap<string, RateCard> {
    return state.rateCardsMap;
  }

  @Selector()
  static getInvoiceLoadsLimit(state: InvoiceStateModel): number {
    return state.invoiceLoadsLimit;
  }

  @Selector()
  static findCommitmentContractOrgIds(state: InvoiceStateModel): string[] {
    return state.commitmentContractOrgIds;
  }

  @Selector()
  static getLabelMatchedCommitmentOrgIds(state: InvoiceStateModel): string[] | null {
    return state.labelMatchedCommitmentOrgIds ?? null;
  }

  @Selector()
  static getSelectedInvoices(state: InvoiceStateModel): Invoice[] {
    return Object.keys(state.selectedInvoices).map((id: string) => state.selectedInvoices[id]);
  }

  @Selector()
  static getCustomers(state: InvoiceStateModel): DropDownValue[] {
    return state.customers;
  }

  @Selector()
  static getInvoicePageStatus(state: InvoiceStateModel): EntityMap<InvoiceType, EntityMap<TabType, InvoicePageStatusFilter>> {
    return state.invoicePageStatus;
  }

  @Selector()
  static getAllCustomers(state: InvoiceStateModel): DropDownValue[] {
    return state.allCustomers;
  }

  @Selector()
  static getReceivableOtherContract(state: InvoiceStateModel): OtherContractFilter {
    return state.receivableOtherContractFilter;
  }

  @Selector()
  static getPayableOtherContract(state: InvoiceStateModel): OtherContractFilter {
    return state.payableOtherContractFilter;
  }

  @Selector()
  static getAllCompletedLoadsForSelection(state: InvoiceStateModel): EntityMap<string, ReadyToInvoice[]> {
    return state.allCompletedLoadsForSelection || {};
  }

  @Action(GetAllCompletedLoadsForSelectionAction)
  getAllCompletedLoadsForSelection(
    {patchState, getState, dispatch}: StateContext<InvoiceStateModel>,
    {orgId, createdTo, searchKey, invoiceType, fromDate, toDate, filterType}: GetAllCompletedLoadsForSelectionAction
  ) {
    const variables = {orgId, createdTo, isCompleted: true, searchKey, invoiceType, fromDate, toDate, types: filterType};
    return this.gqlService
      .queryDataFromGQL<ReadyToInvoice[]>(variables, findAllCompletedLoadsByOrg, 'findAllCompletedLoadsByOrg', this.endpoint)
      .pipe(
        tap((loads: ReadyToInvoice[]) => {
          patchState({
            allCompletedLoadsForSelection: {
              ...(getState().allCompletedLoadsForSelection || {}),
              [createdTo]: loads || []
            }
          });
        }),
        catchError(() => dispatch(new SetNotificationAction('Unable to load all loads for selection', AlertDialogType.ERROR)))
      );
  }

  @Action(ClearAllCompletedLoadsForSelectionAction)
  clearAllCompletedLoadsForSelection(
    {patchState, getState}: StateContext<InvoiceStateModel>,
    {createdTo}: ClearAllCompletedLoadsForSelectionAction
  ) {
    const next = {...(getState().allCompletedLoadsForSelection || {})};
    delete next[createdTo];
    patchState({allCompletedLoadsForSelection: next});
  }

  @Action(GetInvoiceAbleJobsAction)
  getInvoiceAbleJobs({patchState, dispatch, getState}: StateContext<InvoiceStateModel>,
                     {orgId, createdTo, pageNo, pageSize, searchKey, invoiceType, fromDate, toDate, filterType}: GetInvoiceAbleJobsAction) {
    if (!createdTo) {
      return of(null);
    }
    const variables = {orgId, createdTo, pageNo, pageSize, searchKey, invoiceType, fromDate, toDate, types: filterType, labelIds: this.labelIds(getState)};

    return this.gqlService
      .queryDataFromGQL<any>(variables, findInvoiceAbleJobs, 'findInvoiceAbleJobs', this.endpoint)
      .pipe(
        tap(jobs => {
          const obj = {
            content: jobs.data,
            page: {
              totalElements: jobs.totalElements,
              pageSize: jobs.pageSize,
              pageNumber: jobs.pageNo
            }
          } as PageInvoiceAbleJobs;
          patchState({
            jobsForCreatedTo: {...getState().jobsForCreatedTo, [createdTo]: obj}
          });
        }),
        catchError(() => dispatch(new SetNotificationAction('Unable to load jobs', AlertDialogType.ERROR)))
      );
  }

  @Action(GetNoOfCompletedLoadsForCreatedToAction)
  getNoOfCompletedLoadsForCreatedToAction({patchState, dispatch, getState}: StateContext<InvoiceStateModel>,
                                          {orgId, createdToIds, isCompleted, invoiceType, fromDate, toDate, filterType, searchKey}: GetNoOfCompletedLoadsForCreatedToAction) {
    const variables = {orgId, createdToIds, isCompleted, invoiceType, fromDate, toDate, types: filterType, searchKey, labelIds: this.labelIds(getState)};

    return this.gqlService
      .queryDataFromGQL<LoadsCount[]>(variables, countCompletedLoadsByCreatedTo, 'countCompletedLoadsByCreatedTo', this.endpoint)
      .pipe(
        tap((loadsCount: LoadsCount[]) => {
          const noOfCompletedLoadsForCreatedTo = {...getState().noOfCompletedLoadsForCreatedTo};
          loadsCount.forEach(loadCount => {
            noOfCompletedLoadsForCreatedTo[loadCount.createdTo] = loadCount.count;
          });
          patchState({
            noOfCompletedLoadsForCreatedTo
          });
        }),
        catchError(() => dispatch(new SetNotificationAction('Unable to load jobs', AlertDialogType.ERROR)))
      );
  }

  @Action(CreateInvoiceAction)
  createInvoiceAction({patchState, dispatch, getState}: StateContext<InvoiceStateModel>, {createInvoiceInput}: CreateInvoiceAction) {
    const variables = {createInvoiceInput};
    const type = createInvoiceInput.type.includes('PAYABLE') ? 'Payment Schedule' : 'Invoice';
    return this.gqlService.mutateDataFromGQL<any>(variables, createInvoice, 'createInvoice', this.endpoint)
      .pipe(
        tap(invoice => {
          if (invoice.type === InvoiceType.PAYABLE || invoice.type === InvoiceType.PAYABLE_COMMITMENT) {
            this.router.navigate(['/invoice-management/ps-progress-line'], {queryParams: {id: invoice._id}}).then(r => console.log);
          } else if (invoice.type === InvoiceType.RECEIVABLE || invoice.type === InvoiceType.RECEIVABLE_COMMITMENT) {
            this.router.navigate(['/invoice-management/progress-line'], {queryParams: {id: invoice._id}}).then(r => console.log);
          } else {
            console.log('other invoices');
          }
          patchState({
            selectedInvoices: {}
          });
          dispatch(new SetNotificationAction(`${type} created successfully`, AlertDialogType.SUCCESS));
        }),
        catchError(() => dispatch(new SetNotificationAction('Unable to create invoice', AlertDialogType.ERROR)))
      );
  }

  @Action(UpdateInvoiceAction)
  updateInvoiceAction({patchState, dispatch, getState}: StateContext<InvoiceStateModel>, {invoice}: UpdateInvoiceAction) {
    const variables = {updateInvoiceInput: invoice};
    return this.gqlService.mutateDataFromGQL<any>(variables, updateInvoice, 'updateInvoice', this.endpoint)
      .pipe(
        tap(updatedInvoice => {
          patchState({
            selectedInvoice: updatedInvoice
          });
        }),
        catchError(() => dispatch(new SetNotificationAction('Unable to update invoice', AlertDialogType.ERROR)))
      );
  }

  @Action(DisputeInvoiceItemAction)
  disputeInvoiceItemAction(
    {patchState, getState}: StateContext<InvoiceStateModel>,
    {disputeInvoiceItemInput}: DisputeInvoiceItemAction
  ) {
    const variables = {disputeInvoiceItemInput};
    return this.gqlService
      .mutateDataFromGQL<any>(variables, disputeInvoiceItem, 'disputeInvoiceItem', this.endpoint)
      .pipe(
        tap(persistedInvoice => {
          if (persistedInvoice) {
            const currentInvoice = getState().selectedInvoice;
            patchState({
              selectedInvoice: currentInvoice
                ? { ...currentInvoice, ...persistedInvoice }
                : persistedInvoice
            });
          }
        })
      );
  }

  @Action(AcceptInvoiceItemAction)
  acceptInvoiceItemAction(
    {patchState, getState}: StateContext<InvoiceStateModel>,
    {acceptInvoiceItemInput}: AcceptInvoiceItemAction
  ) {
    const variables = {acceptInvoiceItemInput};
    return this.gqlService
      .mutateDataFromGQL<any>(variables, acceptInvoiceItem, 'acceptInvoiceItem', this.endpoint)
      .pipe(
        tap(persistedInvoice => {
          if (persistedInvoice) {
            const currentInvoice = getState().selectedInvoice;
            patchState({
              selectedInvoice: currentInvoice
                ? { ...currentInvoice, ...persistedInvoice }
                : persistedInvoice
            });
          }
        })
      );
  }

  @Action(ChangeCurrencyAction)
  changeCurrencyAction({patchState, dispatch, getState}: StateContext<InvoiceStateModel>, {invoice}: ChangeCurrencyAction) {
    const variables = {updateInvoiceInput: invoice};
    return this.gqlService.mutateDataFromGQL<any>(variables, updateInvoice, 'updateInvoice', this.endpoint)
      .pipe(
        tap(updatedInvoice => {
          patchState({
            selectedInvoice: updatedInvoice
          });
        }),
        catchError(() => dispatch(new SetNotificationAction('Unable to update invoice', AlertDialogType.ERROR)))
      );
  }

  @Action(RemoveLoadAction)
  removeLoad({patchState, dispatch, getState}: StateContext<InvoiceStateModel>, {id, invoiceType, invoiceId}: RemoveLoadAction) {
    const variables = {id, invoiceId, invoiceType};
    return this.gqlService.mutateDataFromGQL<any>(variables, removeLoad, 'removeLoad', this.endpoint)
      .pipe(
        tap(updatedInvoice => {
          if (!updatedInvoice) { return; }
          const remainingLoads = updatedInvoice.loads || [];
          const remainingJobTitles = new Set(
            remainingLoads.map(l => l?.jobTitle).filter(Boolean)
          );
          const oldJobTitles: string[] = updatedInvoice.jobTitles || [];
          const oldInternalRefNos: string[] = updatedInvoice.internalRefNos || [];
          const oldContractRefNos: string[] = updatedInvoice.contractRefNos || [];
          const jobTitles: string[] = [];
          const internalRefNos: string[] = [];
          const contractRefNos: string[] = [];
          oldJobTitles.forEach((jobTitle, idx) => {
            if (remainingJobTitles.has(jobTitle)) {
              jobTitles.push(jobTitle);
              if (idx < oldInternalRefNos.length) {
                internalRefNos.push(oldInternalRefNos[idx]);
              }
              if (idx < oldContractRefNos.length) {
                contractRefNos.push(oldContractRefNos[idx]);
              }
            }
          });
          patchState({
            selectedInvoice: {
              ...updatedInvoice,
              jobTitles,
              internalRefNos,
              contractRefNos
            }
          });
        }),
        catchError(() => dispatch(new SetNotificationAction('Unable to update invoice', AlertDialogType.ERROR)))
      );
  }

  @Action(RemoveAllLoadsAction)
  removeAllLoads({patchState, dispatch, getState}: StateContext<InvoiceStateModel>, {invoiceId, invoiceType}: RemoveAllLoadsAction) {
    const variables = {invoiceId, invoiceType};
    return this.gqlService.mutateDataFromGQL<any>(variables, removeAllLoads, 'removeAllLoads', this.endpoint)
      .pipe(
        tap(updatedInvoice => {
          if (!updatedInvoice) { return; }
          patchState({
            selectedInvoice: {
              ...updatedInvoice,
              jobTitles: [],
              internalRefNos: [],
              contractRefNos: []
            }
          });
        }),
        catchError(() => dispatch(new SetNotificationAction('Unable to update invoice', AlertDialogType.ERROR)))
      );
  }

  @Action(AddLoadsToInvoiceAction)
  addLoadsToInvoice({patchState, dispatch}: StateContext<InvoiceStateModel>, {invoiceId, jpmIds, invoiceType}: AddLoadsToInvoiceAction) {
    const variables = {invoiceId, jpmIds, invoiceType};
    return this.gqlService.mutateDataFromGQL<any>(variables, addLoadsToInvoice, 'addLoadsToInvoice', this.endpoint)
      .pipe(
        tap(updatedInvoice => {
          if (updatedInvoice) {
            patchState({
              selectedInvoice: updatedInvoice
            });
          }
          dispatch(new FindInvoiceByIdAction(invoiceId));
        }),
        catchError(() => dispatch(new SetNotificationAction('Unable to add loads to invoice', AlertDialogType.ERROR)))
      );
  }

  @Action(GetCustomersIdsAction)
  getCustomerIdsAction({patchState, dispatch, getState}: StateContext<InvoiceStateModel>,
                       {orgId, fromDate, toDate, filterType, searchKey}: GetCustomersIdsAction) {
    const completionSubject: Subject<void> = new Subject();
    const variables = {orgId, fromDate, toDate, types: filterType, searchKey, labelIds: this.labelIds(getState)};

    this.gqlService.queryDataFromGQL<[]>(variables, findCustomers, 'findCustomers', this.endpoint)
      .pipe(
        tap(customers => patchState({
          customerIds: customers
        })),
        catchError(() => dispatch(new SetNotificationAction('Unable to load customer ids', AlertDialogType.ERROR)))
      ).subscribe(_ => {
      completionSubject.next();
      completionSubject.complete();
    });
    return completionSubject;
  }

  @Action(GetSupplierIdsAction)
  getSupplierIdsAction({patchState, dispatch, getState}: StateContext<InvoiceStateModel>,
                       {orgId, fromDate, toDate, filterType, searchKey}: GetSupplierIdsAction) {
    const completionSubject: Subject<void> = new Subject();
    const variables = {orgId, fromDate, toDate, types: filterType, searchKey, labelIds: this.labelIds(getState)};

    this.gqlService.queryDataFromGQL<[]>(variables, findSuppliers, 'findSuppliers', this.endpoint)
      .pipe(
        tap(suppliers => patchState({
          supplierIds: suppliers
        })),
        catchError(() => dispatch(new SetNotificationAction('Unable to load supplier ids', AlertDialogType.ERROR)))
      ).subscribe(_ => {
      completionSubject.next();
      completionSubject.complete();
    });
    return completionSubject;
  }

  @Action(GetOrgDetailsAction)
  getOrgDetailsAction({patchState, getState}: StateContext<InvoiceStateModel>, {orgIds}: GetOrgDetailsAction) {
    const completionSubject = new Subject<void>();
    this.invoiceService.getOrgDetails(orgIds).pipe(
      tap(orgDetailsList => {
        const orgDetailsMap = {...getState().orgDetails};
        orgDetailsList.forEach(orgDetails => {
          orgDetailsMap[orgDetails.orgId] = orgDetails;
        });
        patchState({
          orgDetails: orgDetailsMap
        });
      })
    ).subscribe(_ => {
      completionSubject.next();
      completionSubject.complete();
    });
    return completionSubject;
  }

  @Action(GetLoadsByJobFileAndCompletedAction)
  getLoadsByJobFileAndCompletedAction({patchState, dispatch, getState}: StateContext<InvoiceStateModel>,
                                      {orgId, createdTo, jobRefId, isCompleted, pageNo, pageSize, invoiceType}: GetLoadsByJobFileAndCompletedAction) {
    const completionSubject: Subject<void> = new Subject();
    const variables = {orgId, createdTo, jobRefId, isCompleted, pageNo, pageSize, invoiceType, labelIds: this.labelIds(getState)};

    this.gqlService
      .queryDataFromGQL<any>(variables, findLoadsByJobRefIdAndIsCompleted, 'findLoadsByJobRefIdAndIsCompleted', this.endpoint)
      .pipe(
        tap(loads => {
          const obj = {
            content: loads.data,
            page: {
              totalElements: loads.totalElements,
              pageSize: loads.pageSize,
              pageNumber: loads.pageNo
            }
          } as PageReadyToInvoice;

          if (isCompleted) {
            patchState({
              completedLoadsForJob: {...getState().completedLoadsForJob, [jobRefId]: obj}
            });
          } else {
            patchState({
              pendingLoadsForJob: {...getState().pendingLoadsForJob, [jobRefId]: obj}
            });
          }

        }),
        catchError(() => dispatch(new SetNotificationAction('Unable to fetch jobs loads', AlertDialogType.ERROR)))
      ).subscribe(_ => {
      completionSubject.next();
      completionSubject.complete();
    });
    return completionSubject;
  }

  @Action(GetLoadsForJobFileAction)
  getLoadsForJobFileAction({patchState, dispatch, getState}: StateContext<InvoiceStateModel>,
                           {orgId, jobRefId, pageNo, pageSize}: GetLoadsForJobFileAction) {
    const completionSubject: Subject<void> = new Subject();
    const variables = {orgId, jobRefId, pageNo, pageSize};

    this.gqlService.queryDataFromGQL<any>(variables, findLoadsByJobRefId, 'findLoadsByJobRefId', this.endpoint)
      .pipe(
        tap(loads => {
          const obj = {
            content: loads.data,
            page: {
              totalElements: loads.totalElements,
              pageSize: loads.pageSize,
              pageNumber: loads.pageNo
            }
          } as PageReadyToInvoice;
          patchState({
            loadsForJob: {...getState().loadsForJob, [jobRefId]: obj}
          });
        }),
        catchError(() => dispatch(new SetNotificationAction('Unable to fetch jobs loads', AlertDialogType.ERROR)))
      ).subscribe(_ => {
      completionSubject.next();
      completionSubject.complete();
    });
    return completionSubject;
  }

  @Action(SelectAllLoadsActionByOrg)
  selectAllJobLoadAction({patchState, dispatch, getState}: StateContext<InvoiceStateModel>,
                         {orgId, createdTo, isCompleted, checked,  searchKey, invoiceType, fromDate, toDate, filterType}: 
                         SelectAllLoadsActionByOrg) {
    if (checked) {
      const completionSubject: Subject<void> = new Subject();
      const variables = {orgId, createdTo, isCompleted, searchKey, invoiceType, fromDate, toDate, types: filterType, labelIds: this.labelIds(getState)};

      this.gqlService.queryDataFromGQL<any>(variables, findAllCompletedLoadsByOrg, 'findAllCompletedLoadsByOrg', this.endpoint)
        .pipe(
          tap((readyToInvoices: ReadyToInvoice[]) => {
            const selectedLoads = {...getState().selectedLoads};
            const all = readyToInvoices || [];
            const referenceCurrency =
              all.find(rti => !!rti?.rateCardCalculationRequest?.rateSheet?.currencyCode)
                ?.rateCardCalculationRequest?.rateSheet?.currencyCode || '';
            all.forEach(readyToInvoice => {
              const rateSheet = readyToInvoice?.rateCardCalculationRequest?.rateSheet;
              const trips = readyToInvoice?.rateCardCalculationRequest?.trips || [];
              const billableExpenses = (readyToInvoice.expenses || []).map(exp => ({
                  id: exp.id,
                  value: exp.amount,
                  description: exp.costDescription,
                  feeType: exp.feeType

                } as Cost));

              const commissions = (readyToInvoice?.commissions || []).map(exp => ({
                  id: exp.id,
                  value: exp.amount,
                  description: exp.costDescription,
                  feeType: exp.feeType
                } as Cost));

              const addedAdditionalCost =  (readyToInvoice.addedAdditionalCost || []).map(exp => ({
                  id: exp.id,
                  value: exp.amount,
                  description: exp.costDescription,
                  paymentType: exp?.paymentType
                } as Cost));

              const addedOtherCost = (readyToInvoice.addedOtherCost || []).map(exp => ({
                  id: exp.id,
                  value: exp.amount,
                  description: exp.costDescription,
                  paymentType: exp?.paymentType
                } as Cost));
              let addedDiscount;
              if (readyToInvoice.addedDiscount){
                addedDiscount = {
                  id: readyToInvoice?.addedDiscount.id,
                  value: readyToInvoice?.addedDiscount.amount,
                  description: readyToInvoice?.addedDiscount.costDescription,
                  paymentType: readyToInvoice.addedDiscount?.paymentType
              };

            }
              const loadCurrencyCode = rateSheet?.currencyCode || '';
              const load = {
                _id: readyToInvoice._id,
                jobRefId: readyToInvoice.jobRefId,
                loadId: readyToInvoice.loadId,
                loadNumber: readyToInvoice.loadNumber,
                costs: billableExpenses,
                loadCost: readyToInvoice.loadCost,
                jpmId: readyToInvoice.jpmId,
                total: this.rtiExtraServiceService.calculateSubTotal(readyToInvoice),
                createdTo: readyToInvoice.createdTo,
                containerType: readyToInvoice.containerType,
                jobTitle: readyToInvoice.jobTitle,
                defaultOrgCurrencyCode: rateSheet?.defaultOrgCurrencyCode || '',
                currencyCode: loadCurrencyCode,
                exchangeRate: rateSheet?.exchangeRate ?? 0,
                paymentTerm: readyToInvoice.paymentTerm,
                rateCard: readyToInvoice.rateCard,
                locations: readyToInvoice.locations,
                distance: trips.reduce((total, trip) => total + (trip?.distance || 0), 0),
                operationId: readyToInvoice.operationId,
                contractRefNo: readyToInvoice.contractRefNo,
                addedAdditionalCost,
                addedDiscount,
                addedOtherCost,
                vehicleCategories: readyToInvoice.vehicleCategories,
                commissions
              } as InvoiceLoad;
              const existingKeys = Object.keys(selectedLoads);
              const baselineCurrency = existingKeys.length > 0
                ? (selectedLoads[existingKeys[0]].currencyCode || '')
                : referenceCurrency;
              if (!baselineCurrency || !loadCurrencyCode || baselineCurrency === loadCurrencyCode) {
                selectedLoads[load._id] = load;
              }
            });
            patchState({
              selectedLoads
            });
          }),
          catchError(() => dispatch(new SetNotificationAction('Unable to fetch jobs loads', AlertDialogType.ERROR)))
        ).subscribe(_ => {
        completionSubject.next();
        completionSubject.complete();
      });
      return completionSubject;
    } else {

          const jobLoads = {...getState().selectedLoads};

          Object.keys(jobLoads).forEach(key => {
          patchState({
            selectedLoads: produce(getState().selectedLoads, (draft) => {
              delete draft[key];
            }),
          });
      });
    }
  }

  @Action(SelectAllLoadsAction)
  selectAllLoadsAction({patchState, dispatch, getState}: StateContext<InvoiceStateModel>,
                       {orgId, jobRefId, isCompleted, checked}: SelectAllLoadsAction) {

    if (checked) {
      const completionSubject: Subject<void> = new Subject();
      const variables = {orgId, jobRefId, isCompleted, labelIds: this.labelIds(getState)};

      this.gqlService.queryDataFromGQL<any>(variables, findAllCompletedLoadsByJob, 'findAllCompletedLoadsByJob', this.endpoint)
        .pipe(
          tap((readyToInvoices: ReadyToInvoice[]) => {
            const selectedLoads = {...getState().selectedLoads};
            const all = readyToInvoices || [];
            const referenceCurrency =
              all.find(rti => !!rti?.rateCardCalculationRequest?.rateSheet?.currencyCode)
                ?.rateCardCalculationRequest?.rateSheet?.currencyCode || '';
            all.forEach(readyToInvoice => {
              const rateSheet = readyToInvoice?.rateCardCalculationRequest?.rateSheet;
              const trips = readyToInvoice?.rateCardCalculationRequest?.trips || [];
              const billableExpenses = (readyToInvoice.expenses || []).map(exp => ({
                  id: exp.id,
                  value: exp.amount,
                  description: exp.costDescription,
                  feeType: exp.feeType
                } as Cost));

              const commissions = (readyToInvoice?.commissions || []).map(exp => ({
                  id: exp.id,
                  value: exp.amount,
                  description: exp.costDescription,
                  feeType: exp.feeType
                } as Cost));

              const addedAdditionalCost =  readyToInvoice?.addedAdditionalCost?.map(exp => ({
                  id: exp.id,
                  value: exp.amount,
                  description: exp.costDescription,
                  paymentType: exp?.paymentType
                } as Cost));

              const addedOtherCost = readyToInvoice?.addedOtherCost?.map(exp => ({
                  id: exp.id,
                  value: exp.amount,
                  description: exp.costDescription,
                  paymentType: exp?.paymentType
                } as Cost));
              let addedDiscount;
              if (readyToInvoice.addedDiscount){
                  addedDiscount = {
                    id: readyToInvoice?.addedDiscount.id,
                    value: readyToInvoice?.addedDiscount.amount,
                    description: readyToInvoice?.addedDiscount.costDescription,
                    paymentType: readyToInvoice?.addedDiscount?.paymentType
                };

              }
              const loadCurrencyCode = rateSheet?.currencyCode || '';
              const load = {
                // eslint-disable-next-line no-underscore-dangle
                _id: readyToInvoice._id,
                jobRefId: readyToInvoice.jobRefId,
                loadId: readyToInvoice.loadId,
                loadNumber: readyToInvoice.loadNumber,
                costs: billableExpenses,
                loadCost: readyToInvoice.loadCost,
                jpmId: readyToInvoice.jpmId,
                total: this.rtiExtraServiceService.calculateSubTotal(readyToInvoice),
                createdTo: readyToInvoice.createdTo,
                containerType: readyToInvoice.containerType,
                jobTitle: readyToInvoice.jobTitle,
                defaultOrgCurrencyCode: rateSheet?.defaultOrgCurrencyCode || '',
                currencyCode: loadCurrencyCode,
                exchangeRate: rateSheet?.exchangeRate ?? 0,
                paymentTerm: readyToInvoice.paymentTerm,
                rateCard: readyToInvoice.rateCard,
                locations: readyToInvoice.locations,
                distance: trips.reduce((total, trip) => total + (trip?.distance || 0), 0),
                operationId: readyToInvoice.operationId,
                contractRefNo: readyToInvoice.contractRefNo,
                addedAdditionalCost,
                addedDiscount,
                addedOtherCost,
                vehicleCategories: readyToInvoice.vehicleCategories,
                commissions
              } as InvoiceLoad;

              const existingKeys = Object.keys(selectedLoads);
              const baselineCurrency = existingKeys.length > 0
                ? (selectedLoads[existingKeys[0]].currencyCode || '')
                : referenceCurrency;
              if (!baselineCurrency || !loadCurrencyCode || baselineCurrency === loadCurrencyCode) {
                selectedLoads[load._id] = load;
              }
            });
            patchState({
              selectedLoads
            });
          }),
          catchError(() => dispatch(new SetNotificationAction('Unable to fetch jobs loads', AlertDialogType.ERROR)))
        ).subscribe(_ => {
        completionSubject.next();
        completionSubject.complete();
      });
      return completionSubject;
    } else {
      const jobLoads = {...getState().selectedLoads};
      Object.keys(jobLoads).forEach(key => {
        if (jobLoads[key].jobRefId === jobRefId) {
          patchState({
            selectedLoads: produce(getState().selectedLoads, (draft) => {
              delete draft[key];
            }),
          });
        }
      });
    }
  }

  @Action(SelectLoadAction)
  selectLoadAction({patchState, dispatch, getState}: StateContext<InvoiceStateModel>, {jpmId, jobRefId, checked}: SelectLoadAction) {
    if (checked) {
      const completedLoads = [...getState().completedLoadsForJob[jobRefId].content];
      const readyToInvoice = completedLoads.find(rti => rti.jpmId === jpmId);
      let billableExpenses = [];
      let addedAdditionalCost = [];
      let addedOtherCost = [];
      let addedDiscount;
      billableExpenses = readyToInvoice.expenses.map(exp => ({
          id: exp.id,
          value: exp.amount,
          description: exp.costDescription,
          feeType: exp.feeType
        } as Cost));

      const commissions = readyToInvoice?.commissions.map(exp => ({
          id: exp.id,
          value: exp.amount,
          description: exp.costDescription,
          feeType: exp.feeType
        } as Cost));

      addedAdditionalCost =  readyToInvoice?.addedAdditionalCost.map(exp => ({
          id: exp.id,
          value: exp.amount,
          description: exp.costDescription,
          paymentType: exp?.paymentType
        } as Cost));

      addedOtherCost = readyToInvoice?.addedOtherCost.map(exp => ({
          id: exp.id,
          value: exp.amount,
          description: exp.costDescription,
          paymentType: exp?.paymentType
        } as Cost));

      if (readyToInvoice.addedDiscount){
        addedDiscount = {
          id: readyToInvoice?.addedDiscount.id,
          value: readyToInvoice?.addedDiscount.amount,
          description: readyToInvoice?.addedDiscount.costDescription,
          paymentType: readyToInvoice?.addedDiscount?.paymentType
      };

    }
      const load = {
        // eslint-disable-next-line no-underscore-dangle
        _id: readyToInvoice._id,
        loadId: readyToInvoice.loadId,
        loadNumber: readyToInvoice.loadNumber,
        loadCost: readyToInvoice.loadCost,
        costs: billableExpenses,
        jpmId: readyToInvoice.jpmId,
        jobRefId: readyToInvoice.jobRefId,
        total: this.rtiExtraServiceService.calculateSubTotal(readyToInvoice),
        createdTo: readyToInvoice.createdTo,
        containerType: readyToInvoice.containerType,
        jobTitle: readyToInvoice.jobTitle,
        defaultOrgCurrencyCode: readyToInvoice.rateCardCalculationRequest.rateSheet.defaultOrgCurrencyCode,
        currencyCode: readyToInvoice.rateCardCalculationRequest.rateSheet.currencyCode,
        exchangeRate: readyToInvoice.rateCardCalculationRequest.rateSheet.exchangeRate,
        paymentTerm: readyToInvoice.paymentTerm,
        rateCard: readyToInvoice.rateCard,
        locations: readyToInvoice.locations,
        distance: readyToInvoice.rateCardCalculationRequest.trips.reduce((total, trip) => total + trip.distance, 0),
        operationId: readyToInvoice.operationId,
        contractRefNo: readyToInvoice.contractRefNo,
        addedAdditionalCost,
        addedDiscount,
        addedOtherCost,
        vehicleCategories: readyToInvoice.vehicleCategories,
        commissions
      } as InvoiceLoad;
      patchState({
        selectedLoads: {...getState().selectedLoads, [load._id]: load}
      });
    } else {
      patchState({
        selectedLoads: produce(getState().selectedLoads, (draft) => {
          Object.keys(draft).forEach(key => {
            if (draft[key]?.jpmId === jpmId) {
              delete draft[key];
            }
          });
        }),
      });
    }
  }

  @Action(FindByInvoiceTypeAndApprovalTypeAction)
  findByITypeAndAType({patchState, dispatch, getState}: StateContext<InvoiceStateModel>,
                      {
                        orgId,
                        tabType,
                        approvalType,
                        pageNo,
                        pageSize,
                        invoiceType,
                        searchKey,
                        fromDate,
                        toDate,
                        createdTo,
                        all
                      }: FindByInvoiceTypeAndApprovalTypeAction) {
    const completionSubject: Subject<void> = new Subject();

    if(createdTo?.length > 0){
      if(createdTo.includes('all-orgs')){
        createdTo = [];
        all = false;
      }
    }

    const variables = {orgId, tabType, approvalType, pageNo, pageSize, invoiceType, searchKey, fromDate, toDate, createdTo, all,
      labelIds: this.labelIds(getState)};
    return this.gqlService
      .queryDataFromGQL<any>(variables, findInvoicesByInvoiceTypeAndApprovalType, 'findInvoicesByInvoiceTypeAndApprovalType', this.endpoint)
      .pipe(
        tap(page => {
          const obj = {
            content: page.data,
            page: {
              totalElements: page.totalElements,
              pageSize: page.pageSize,
              pageNumber: page.pageNo
            }
          } as PageInvoices;
          if(all){
            if (obj.page.totalElements > 0){
              patchState({
                invoicesAll: {...getState().invoicesAll, [tabType.toString()]: obj}
              });
            }
          }else{
            patchState({
              invoices: {...getState().invoices, [tabType.toString()]: obj}
          });
          }
        }),
        catchError(() => dispatch(new SetNotificationAction('Unable to fetch invoices', AlertDialogType.ERROR)))
      ).subscribe(_ => {
        completionSubject.next();
        completionSubject.complete();
      });
    return completionSubject;
  }

  @Action(GetReceivedInvoicesAction)
  getReceivedInvoices({patchState, dispatch, getState}: StateContext<InvoiceStateModel>,
                      {
                        createdTo,
                        approvalType,
                        pageNo,
                        pageSize,
                        fromDate,
                        toDate,
                        searchKey,
                        invoiceType,
                        all
                      }: GetReceivedInvoicesAction) {
    const completionSubject: Subject<void> = new Subject();

    const fetchAll = !!all;

    const variables = {
      createdTo,
      approvalType,
      pageNo,
      pageSize,
      invoiceType,
      fromDate,
      toDate,
      searchKey: searchKey ?? '',
      all: fetchAll
    };

    return this.gqlService
      .queryDataFromGQL<any>(variables, findReceivedInvoicesByApprovalState, 'findReceivedInvoicesByApprovalState', this.endpoint)
      .pipe(
        tap(page => {
          const obj = {
            content: page.data,
            page: {
              totalElements: page.totalElements,
              pageSize: page.pageSize,
              pageNumber: page.pageNo
            }
          } as PageInvoices;
          if (fetchAll) {
            if (obj.page.totalElements > 0) {
              patchState({
                invoicesAll: {...getState().invoicesAll, [TabType.UNPAID.toString()]: obj}
              });
            }
          } else {
            patchState({
              invoices: {...getState().invoices, [TabType.UNPAID.toString()]: obj}
            });
          }
        }),
        catchError(() => dispatch(new SetNotificationAction('Unable to fetch received invoices', AlertDialogType.ERROR)))
      ).subscribe(_ => {
        completionSubject.next();
        completionSubject.complete();
      });
  }

  @Action(FindByInvoiceTypeAndOverdueTypeAction)
  findByITypeAndOType({patchState, dispatch, getState}: StateContext<InvoiceStateModel>,
                      {orgId, tabType, overdueState, pageNo, pageSize, invoiceType, fromDate, toDate, searchKey}: FindByInvoiceTypeAndOverdueTypeAction) {
    const completionSubject: Subject<void> = new Subject();
    const variables = {orgId, tabType, overdueState, pageNo, pageSize, invoiceType, fromDate, toDate, searchKey,
      labelIds: this.labelIds(getState)};
    return this.gqlService
      .queryDataFromGQL<any>(variables, findByInvoiceTypeAndOverdueType, 'findByInvoiceTypeAndOverdueType', this.endpoint)
      .pipe(
        tap(page => {
          const obj = {
            content: page.data,
            page: {
              totalElements: page.totalElements,
              pageSize: page.pageSize,
              pageNumber: page.pageNo
            }
          } as PageInvoices;
          patchState({
            invoices: {...getState().invoices, [tabType.toString()]: obj}
          });
        }),
        catchError(() => dispatch(new SetNotificationAction('Unable to fetch invoices', AlertDialogType.ERROR)))
      ).subscribe(_ => {
        completionSubject.next();
        completionSubject.complete();
      });
    return completionSubject;
  }

  @Action(FindInvoiceByIdAction)
  findByInvoiceById({patchState, dispatch, getState}: StateContext<InvoiceStateModel>,
                    {id}: FindInvoiceByIdAction) {
    const variables = {id};
    return this.gqlService.queryDataFromGQL<any>(variables, findInvoiceById, 'findInvoiceById', this.endpoint)
      .pipe(
        tap(invoice => {
          patchState({
            selectedInvoice: invoice
          });
        }),
        catchError(() => dispatch(new SetNotificationAction('Unable to fetch invoices', AlertDialogType.ERROR)))
      );
  }

  @Action(RemoveSelectedLoadsAction)
  removeSelectedLoads({patchState}: StateContext<InvoiceStateModel>, {}: RemoveSelectedLoadsAction) {
    patchState({
      selectedLoads: {}
    });
  }

  @Action(GetAllTaxByCountryAction)
  getAllTaxByCountryAction({patchState, dispatch, getState}: StateContext<InvoiceStateModel>,
                           {countryCode}: GetAllTaxByCountryAction) {
    const variables = {countryCode};
    return this.gqlService.queryDataFromGQL<any>(variables, fidByCountry, 'findByCountry', this.endpoint)
      .pipe(
        tap(tax => {
          patchState({
            taxes: tax
          });
        }),
        catchError(() => dispatch(new SetNotificationAction('Unable to fetch taxes', AlertDialogType.ERROR)))
      );
  }

  @Action(LoadRateCardsAction)
  loadRateCards({dispatch, getState, patchState}: StateContext<InvoiceStateModel>, {orgId, contractType, organizationId, searchKey}: LoadRateCardsAction) {
    // Clear previously loaded org's rate cards so they don't show while the new list loads
    patchState({rateCards: []});
    return this.invoiceService.getRateCardsByFilters(orgId, contractType, organizationId, '', searchKey)
      .pipe(
        map(rateCards => patchState({rateCards})),
        catchError(() => dispatch(new SetNotificationAction('Error loading Rate Cards', AlertDialogType.ERROR)))
      );
  }

  @Action(ChangeRateCardForJobAction)
  changeRateCardForTripAction({patchState, dispatch, getState}: StateContext<InvoiceStateModel>,
                              {jpmId, createdTo,  rateCardId}: ChangeRateCardForJobAction) {
    const variables = {jpmId, createdTo, rateCardId};
    return this.gqlService.mutateDataFromGQL<any>(variables, changeRateCardForTrip, 'changeRateCardForTrip', this.endpoint)
      .pipe(
        tap(message => {
          dispatch(new SetNotificationAction(message, AlertDialogType.SUCCESS));
        }),
        catchError(() => dispatch(new SetNotificationAction('Unable to update invoice', AlertDialogType.ERROR)))
      );
  }

  @Action(UploadPdfAndGetId)
  downloadInvoicePdfAction({patchState, dispatch, getState}: StateContext<InvoiceStateModel>, {orgId, invoiceId, fileName}: UploadPdfAndGetId) {
    const variables = {orgId, invoiceId};
    return this.gqlService.mutateDataFromGQL<any>(variables, uploadPdfAndGetId, 'uploadPdfAndGetId', this.endpoint)
      .pipe(
        tap(fileId => {
          dispatch(new GetPreSignedFile(fileId, fileName));
          patchState({
            pdfFileId: fileId
          });
        }),
        catchError(() => dispatch(new SetNotificationAction('Unable get pdf id', AlertDialogType.ERROR)))
      );
  }

  @Action(GetPreSignedFile)
  downloadJobSummary({dispatch, patchState, getState}: StateContext<InvoiceStateModel>, {fileId, fileName}: GetPreSignedFile) {
    return this.invoiceService.getPdfPreSIgnedUrl(fileId)
      .pipe(
        mergeMap(res => this.invoiceService.getPDFFileData(res.url).pipe(map(blob => ({blob, originalFileName: res.originalFileName})))),
        tap(({blob, originalFileName}) => {
          const resolvedName = originalFileName || fileName || 'Invoice.pdf';
          const a = document.createElement('a');
          a.href = URL.createObjectURL(blob);
          a.download = resolvedName.endsWith('.pdf') ? resolvedName : `${resolvedName}.pdf`;
          document.body.appendChild(a);
          a.click();
          dispatch(new SetSpinner(false));
        }),
        catchError(() => dispatch(new SetNotificationAction('Error Downloading Summary PDF', AlertDialogType.ERROR)))
      );
  }

  @Action(FindAllCurrencyAction)
  findAllCurrencyAction({patchState, dispatch}: StateContext<InvoiceStateModel>, {}: FindAllCurrencyAction) {
    const variables = {};
    return this.gqlService.queryDataFromGQL<any>(variables, findAllCurrency, 'findAllCurrency', this.endpoint)
      .pipe(
        tap(currencies => {
          patchState({
            currencies
          });
        }),
        catchError(() => dispatch(new SetNotificationAction('Unable to find currencies', AlertDialogType.ERROR)))
      );
  }

  @Action(GetRateCardsByIds)
  getRateCardsByIds({patchState, dispatch, getState}: StateContext<InvoiceStateModel>, {rateCardIds}: GetRateCardsByIds) {
    return this.invoiceService.getRateCardsByIds(rateCardIds)
      .pipe(
        tap(rateCards => {
          const rateCardsMap = {...getState().rateCardsMap};
          rateCards.forEach(rateCard => {
            rateCardsMap[rateCard.rateCardId] = rateCard;
          });
          patchState({
            rateCardsMap
          });
        }),
        catchError(() => dispatch(new SetNotificationAction('Unable to get rate cards', AlertDialogType.ERROR)))
      );
  }

  @Action(ResetInvoiceState)
  resetInvoiceState({patchState, getState}: StateContext<InvoiceStateModel>) {
    const currentState = getState();
    const invoicePageStatus = {...currentState.invoicePageStatus};
    const receivableOtherContractFilter = {...currentState.receivableOtherContractFilter};
    const payableOtherContractFilter = {...currentState.payableOtherContractFilter};

    return patchState({
      ...getNewInvoice(),
      invoicePageStatus,
      receivableOtherContractFilter,
      payableOtherContractFilter
    });
  }

  @Action(ClearInvoicesListAction)
  clearInvoicesList({patchState}: StateContext<InvoiceStateModel>) {
    return patchState({
      invoices: {},
      invoicesAll: {}
    });
  }

  @Action(ResetInvoiceMainState)
  resetInvoiceMainState({patchState, getState}: StateContext<InvoiceStateModel>) {
    const currentState = getState();
    const receivableOtherContractFilter = {...currentState.receivableOtherContractFilter};
    const payableOtherContractFilter = {...currentState.payableOtherContractFilter};

    return patchState({
      ...getNewInvoice(),
      receivableOtherContractFilter,
      payableOtherContractFilter
    });
  }

  @Action(GetInvoiceLoadsLimit)
  getInvoiceLoadsLimit({patchState, dispatch, getState}: StateContext<InvoiceStateModel>, {orgId}: GetInvoiceLoadsLimit) {
    return this.invoiceService.getOrganizationInvoiceLoadsLimit(orgId)
      .pipe(
        tap(invoiceLoadsLimit => {
          patchState({
            invoiceLoadsLimit
          });
        }),
        catchError(() => dispatch(new SetNotificationAction('Unable to get invoice loads limit', AlertDialogType.ERROR)))
      );
  }

  @Action(FindCommitmentContractOrganizations)
  findCommitmentSuppliers({patchState, dispatch, getState}: StateContext<InvoiceStateModel>,
                          {orgId, contractType, fromDate, toDate}: FindCommitmentContractOrganizations) {
    return this.invoiceService.findCommitmentContractOrganizations(orgId, contractType, fromDate, toDate)
      .pipe(
        tap(commitmentContractOrgIds => {
          patchState({
            commitmentContractOrgIds
          });
        }),
        catchError(() => dispatch(new SetNotificationAction('Unable to get commitment suppliers', AlertDialogType.ERROR)))
      );
  }

  @Action(FindCommitmentInvoicesForOrgAction)
  findByInvoiceForSupplierAction({patchState, dispatch, getState}: StateContext<InvoiceStateModel>,
                                 {orgId, organizationId, invoiceType, pageNo,
                                   pageSize, searchKey, fromDate, toDate}: FindCommitmentInvoicesForOrgAction) {
    const completionSubject: Subject<void> = new Subject();
    const variables = {orgId, organizationId, invoiceType, pageNo, pageSize, searchKey, fromDate, toDate, labelIds: this.labelIds(getState)};
    return this.gqlService
      .queryDataFromGQL<any>(variables, findCommitmentInvoicesForOrganization, 'findCommitmentInvoicesForOrganization', this.endpoint)
      .pipe(
        tap(page => {
          const obj = {
            content: page.data,
            page: {
              totalElements: page.totalElements,
              pageSize: page.pageSize,
              pageNumber: page.pageNo
            }
          } as PageInvoices;
          patchState({
            supplierInvoices: {...getState().invoices, [organizationId]: obj}
          });
        }),
        catchError(() => dispatch(new SetNotificationAction('Unable to fetch organization invoices', AlertDialogType.ERROR)))
      ).subscribe(_ => {
        completionSubject.next();
        completionSubject.complete();
      });
    return completionSubject;
  }

  @Action(UpdateReadyToInvoiceAction)
  updateReadyToInvoiceAction({patchState, dispatch, getState}: StateContext<InvoiceStateModel>, {readyToInvoice}: UpdateReadyToInvoiceAction) {
    const {_id, addedAdditionalCost , addedOtherCost, expenses, addedDiscount, commissions} = readyToInvoice;
    const variables = {UpdateReadyToInvoiceDiscountCostInput: {_id, addedAdditionalCost, addedDiscount, addedOtherCost, expenses, commissions}};
    return this.gqlService.mutateDataFromGQL<any>(variables, updateReadyToInvoiceCostsDiscounts, 'updateReadyToInvoiceCostsDiscounts', this.endpoint)
      .pipe(
        tap(updatedInvoice => {
          // Only update state if jobRefId exists and data is in state
          if (readyToInvoice.jobRefId) {
            const state = getState();
            const data = state.completedLoadsForJob[readyToInvoice.jobRefId];
            
            if (data && data.content) {
              const updatedData = data.content.map(item => {
                if (item._id === updatedInvoice._id) {
                  return {
                    ...item,
                    ...updatedInvoice
                  };
                }
                return item;
              });
              
              patchState({
                completedLoadsForJob: {
                  ...state.completedLoadsForJob,
                  [readyToInvoice.jobRefId]: {
                    ...data,
                    content: updatedData
                  }
                }
              });
            }
          }
          
          dispatch(new SetNotificationAction('Invoice updated successfully', AlertDialogType.SUCCESS));
        }),
        catchError((error) => {
          dispatch(new SetNotificationAction('Unable to update ready to invoice', AlertDialogType.ERROR));
          return of(null);
        })
      );
  }

  @Action(ChangeInvoicedStateAction)
  changeInvoicedState({dispatch}: StateContext<InvoiceStateModel>,
                      {updateVCStates}: ChangeInvoicedStateAction) {
    const variables = {updateVCStates};
    return this.gqlService.mutateDataFromGQL<any>(variables, changeInvoicedState, 'changeInvoicedState', this.endpoint);
  }

  @Action(SelectInvoicesAction)
  selectInvoices({patchState, getState}: StateContext<InvoiceStateModel>,
                 {invoiceIds}: SelectInvoicesAction) {
    const variables = {invoiceIds};
    return this.gqlService.mutateDataFromGQL<any>(variables, findInvoicesByIds, 'findInvoicesByIds', this.endpoint)
      .pipe(
        tap(data => {
          const invoices: EntityMap<string, Invoice> = {...getState().selectedInvoices};
          data.forEach((invoice: Invoice) => {
            invoices[invoice._id] = invoice;
          });
          patchState({
            selectedInvoices: invoices
          });
        })
      )
      .subscribe();
  }

  @Action(UpdateFuelRateInvoicedStateAction)
  updateInvoiceStateForFRInvoices({}: StateContext<InvoiceStateModel>,
                                  {invoiceIds, invoiceType}: UpdateFuelRateInvoicedStateAction) {
    const variables = {invoiceIds, invoiceType};
    return this.gqlService.mutateDataFromGQL<any>(variables, updateInvoicedState, 'updateInvoiceStateForFuelRateInvoices', this.endpoint);
  }

  @Action(UpdateExpensesAction)
  updateAdditionalCost({}: StateContext<InvoiceStateModel>,
                       {id, expenses}: UpdateExpensesAction) {
    const variables = {id, expenses};
    return this.gqlService.mutateDataFromGQL<any>(variables, updateExpenses, 'updateExpenses', this.endpoint).subscribe();
  }

  @Action(UpdateInvoicePageStatusAction)
  updateInvoicePageStatus({patchState, getState}: StateContext<InvoiceStateModel>,
                         {invoicePageStatus, tabType, invoiceType}: UpdateInvoicePageStatusAction) {

                          patchState({
      invoicePageStatus: {...getState().invoicePageStatus, [invoiceType]: {...getState().invoicePageStatus[invoiceType], [tabType]: invoicePageStatus}}
    });
  }

  @Action(LoadCustomersAction)
  getCustomers({patchState, dispatch}: StateContext<InvoiceStateModel>, {searchKey}: LoadCustomersAction) {
    const {user: {orgId}} = this.store.selectSnapshot(state => state.auth);
    return this.organizationService.getOrganizationsByOrgIdAndOrgType(orgId, OrganizationType.ORG_PARTNER.toString(), searchKey)
      .pipe(
        tap((organizations: Organization[]) => {
          const orgData = organizations.map(organization => ({
              id: organization.id,
              value: organization.orgName
            }));
          patchState({
            customers: orgData,
          });
          if(searchKey === ''){
            patchState({
              allCustomers: orgData
            });
          }
        }),
        catchError((e) => dispatch(new SetNotificationAction('Error loading customer organizations', AlertDialogType.ERROR)))
      );
  }

  @Action(DownloadInvoicesAction)
  downloadInvoices(ctx: StateContext<InvoiceStateModel>, action: DownloadInvoicesAction) {
    // Generate custom filename for dialog display based on invoice type
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    let hours = now.getHours();
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // Convert 0 to 12

    // Determine prefix based on invoice type
    let prefix = 'invoice';
    if (action.invoiceType && (
      action.invoiceType === InvoiceType.PAYABLE || 
      action.invoiceType === InvoiceType.PAYABLE_COMMITMENT || 
      action.invoiceType === InvoiceType.PAYABLE_FUEL_RATE_FINAL
    )) {
      prefix = 'payment-schedule';
    }

    const customFileName = `${prefix}-${year}-${month}-${day}-${hours}.${minutes}${ampm}.xlsx`;

    // Reset progress when starting with custom filename
    ctx.dispatch(new SetDownloadProgress(0, 'invoice', customFileName));

    // Get user info from auth state
    const {user: {orgId, userId}} = this.store.selectSnapshot(state => state.auth);

    const variables = {
      orgId,
      userId,
      downloadType: action.downloadType,
      selectAll: action.selectAll,
      selectedIds: action?.selectedInvoices,
      excludeIds: action?.excludeIds,
      toDate: action?.toDate,
      fromDate: action?.fromDate
    };

    return this.gqlService.mutateDataFromGQL<any>(
      variables,
      downloadInvoicesDetailedReport,
      'generateDetailedReportForInvoices',
      this.endpoint
    ).pipe(
      tap((response: any) => {
        if (response?.success && response?.metadata) {
          const metadata = response.metadata;
          // @ts-ignore - TypeScript has issues with chained pipe on Firebase observable
          this.firebaseService
            .listenToNotifications(
              metadata.orgId,
              'PROGRESS_MONITOR', // notificationType is fixed
              metadata.userId,
              metadata.eventType,
              metadata.eventId,
              undefined // Listen to entire collection
            )
            .pipe(
              // @ts-ignore
              tap((firebaseData: any) => {
                // Handle collection changes (array of changes)
                if (Array.isArray(firebaseData)) {
                  firebaseData.forEach((change: any) => {
                    // Try multiple ways to extract data
                    const data =
                      change.payload?.doc?.data() || change.payload || change;

                    if (data) {
                      // Update progress in shared state
                      if (data.progress !== undefined) {
                        ctx.dispatch(new SetDownloadProgress(data.progress, 'invoice'));
                      }

                      // Check if progress is 100% and download URL is available
                      if (
                        data.progress === 100 &&
                        data.downloadUrl &&
                        data.status === 'COMPLETED'
                      ) {
                        try {
                          const newWindow = window.open(
                            data.downloadUrl,
                            '_blank'
                          );
                          if (!newWindow || newWindow.closed) {
                            window.location.href = data.downloadUrl;
                          }
                        } catch (error) {
                          // Fallback to direct navigation
                          window.location.href = data.downloadUrl;
                        }
                      } else if (data.error) {
                        // Reset progress on error
                        ctx.dispatch(new SetDownloadProgress(0, 'invoice'));
                        ctx.dispatch(
                          new SetNotificationAction(
                            data.message || 'Error generating invoice report',
                            AlertDialogType.ERROR
                          )
                        );
                      }
                    }
                  });
                }

                // Handle single document changes
                if (firebaseData && firebaseData.payload) {
                  // Try multiple ways to extract data
                  const data =
                    firebaseData.payload.data?.() ||
                    firebaseData.payload ||
                    firebaseData;
                  if (data) {
                    // Update progress in shared state
                    if (data.progress !== undefined) {
                      ctx.dispatch(new SetDownloadProgress(data.progress, 'invoice'));
                    }
                    if (
                      data.progress === 100 &&
                      data.downloadUrl &&
                      data.status === 'COMPLETED'
                    ) {
                      try {
                        const newWindow = window.open(
                          data.downloadUrl,
                          '_blank'
                        );
                        if (!newWindow || newWindow.closed) {
                          window.location.href = data.downloadUrl;
                        }
                      } catch (error) {
                        window.location.href = data.downloadUrl;
                      }
                    } else if (data.error) {
                      // Reset progress on error
                      ctx.dispatch(new SetDownloadProgress(0, 'invoice'));
                      ctx.dispatch(
                        new SetNotificationAction(
                          data.message || 'Error generating invoice report',
                          AlertDialogType.ERROR
                        )
                      );
                    }
                  }
                }
              }),
              catchError((error: any) => {
                // Reset progress on error
                ctx.dispatch(new SetDownloadProgress(0, 'invoice'));
                ctx.dispatch(
                  new SetNotificationAction(
                    'Error monitoring invoice report generation progress',
                    AlertDialogType.ERROR
                  )
                );
                return of(null);
              })
            )
            // @ts-ignore
            .subscribe(() => {});
        } else {
          ctx.dispatch(
            new SetNotificationAction(
              response?.message || 'Error starting invoice report generation',
              AlertDialogType.ERROR
            )
          );
        }
      }),
      catchError((error) => {
        console.error('Error requesting invoice report generation:', error);
        ctx.dispatch(new SetNotificationAction(
          'Error requesting invoice report generation',
          AlertDialogType.ERROR
        ));
        return throwError(() => error);
      })
    );
  }

  @Action(LoadAllCustomersAction)
  loadAllCustomers({patchState, dispatch}: StateContext<InvoiceStateModel>) {
    const {user: {orgId}} = this.store.selectSnapshot(state => state.auth);
    return this.organizationService.getOrganizationsByOrgIdAndOrgType(orgId, OrganizationType.ORG_PARTNER.toString(), '')
      .pipe(
        tap((organizations: Organization[]) => {
          patchState({
            allCustomers: organizations.map(organization => ({
                id: organization.id,
                value: organization.orgName
              }))
          });
        }),
        catchError((e) => dispatch(new SetNotificationAction('Error loading customer organizations', AlertDialogType.ERROR)))
      );
  }

  @Action(UpdateReceivableOtherContractFilterAction)
  updateReceivableOtherContractFilter({patchState}: StateContext<InvoiceStateModel>, {filter}: UpdateReceivableOtherContractFilterAction) {
    patchState({
      receivableOtherContractFilter: filter
    });
  }

  @Action(UpdatePayableOtherContractFilterAction)
  updatePayableOtherContractFilter({patchState}: StateContext<InvoiceStateModel>, {filter}: UpdatePayableOtherContractFilterAction) {
    patchState({
      payableOtherContractFilter: filter
    });
  }

}




